


export default [
    {
      path: '/admin-categories/',
      name: 'Categories',
      component: () => import('../components/Categories.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-category-details/',
      name: 'CategoryDetails',
      component: () => import('../components/CategoryDetails.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-category-groups/',
      name: 'CategoryGroups',
      component: () => import('../components/CategoryGroups.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-category-groups-details/',
      name: 'CategoryGroupsDetails',
      component: () => import('../components/CategoryGroupsDetails.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-templates/',
      name: 'Templates',
      component: () => import('../components/Templates.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-templates-details/',
      name: 'TemplatesDetails',
      component: () => import('../components/TemplatesDetails.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-uom/',
      name: 'Uom',
      component: () => import('../components/Uom.vue'),
      meta: {
                authenticate: true
            }
    },
    {
      path: '/admin-uom-details/',
      name: 'UomDetails',
      component: () => import('../components/UomDetails.vue'),
      meta: {
                authenticate: true
            }
    },

  ]
